import './lncanada3/style';
import FormStructure from './lncanada3/form_structure';

export default FormStructure;